

class VIPCardDetailViewController extends MUIViewController
{
    
}